<template>
  <div
    class="col relative-position"
  >
    <q-scroll-area
      v-if="showingBadgesTitleDisplay.length > 0"
      ref="scrollHorizontal"
      style="height: 30px; width: 100%; z-index: 1"
      class="inline q-gutter-y-xs absolute text-left text-no-wrap"
    >
      <showing-badge
        v-for="showingBadge in showingBadgesTitleDisplay"
        :key="showingBadge.id"
        v-touch-pan.mouse.horizontal="dragScrollMove"
        size="sm"
        :showing-badge="showingBadge"
        dense
        :color="getTextColor(showingBadge.color)"
        :class="{ 'bg-warning': showingBadge.color === null }"
        :style="{ 'background-color': showingBadge.color !== null ? showingBadge.color : undefined }"
        display-title-on-button
      />
    </q-scroll-area>
    <q-btn
      :color="isDisabled ? 'grey-5' : isShowtimesDarkMode ? 'transparent' : 'grey-opacity-1'"
      class="showing text-weight-bold text-body1 items-start justify-start q-btn__content_full_width"
      :class="{
        past: showing.localPast,
        current: showing.current,
        'q-mt-md': !isShowtimeGrid || showingBadgesTitleDisplay.length > 0,
        'text-white': isShowtimesDarkMode && !isMoviePage,
        'text-grey-7': !isShowtimesDarkMode || isMoviePage,
        'q-mb-sm': !salesEnabled,
        [showing.displayMetaData && showing.displayMetaData.classes]: true
      }"
      :padding="isShowtimeGrid ? 'xs 0 0 xs' : 'sm 0 0 sm'"
      style="position: relative; overflow: hidden;"
      :style="{
        width: getWidth,
        'min-height': isShowtimeGrid ? '44px' : '100px',
        'border-radius': `${borderRadius}px`,
        'pointer-events': salesEnabled ? undefined : 'none',
        'line-height': isShowtimeGrid ? '1.3' : undefined,
        'letter-spacing': isShowtimeGrid ? '0' : undefined,
        'border': !isShowtimesDarkMode ? undefined: '1px solid'
      }"
      :disable="isDisabled"
      stack
      align="left"
      @click="salesEnabled && $emit('select-showing', showing)"
      @contextmenu.prevent="salesEnabled && $emit('show-held-seat-dialog')"
    >
      <div
        class="text-left full-width"
        :class="{
          'text-grey-7': isDisabled,
          'text-white': isShowtimesDarkMode,
          [`text-${buttonColor}`]: (!isShowtimesDarkMode || !isDisabled) && buttonColor !== 'custom' && !isMoviePage,
        }"
        :style="{ color: textColor }"
      >
        {{ $d(showing.movieSiteTime, 'shortTime') }}
      </div>

      <div
        class="text-left full-width"
        :style="{ 'font-size': isShowtimeGrid ? '10px' : '11px', }"
      >
        Ends at {{ $d(showing.siteEndTime, 'shortTime') }}
      </div>
      <div
        class="row items-end justify-start"
        style="width: calc(100% + 8px); margin-left: -8px;"
        :style="{
          'padding-left': isShowtimeGrid ? '4px' : undefined,
          'padding-bottom': showButtonProgressBar? '6px' : undefined,
          'background-color': getBackgroundColorHex,
        }"
        :class="{
          'q-mt-md': !isShowtimeGrid,
          [`bg-${buttonColor}`]: !isDisabled && buttonColor !== 'custom' && !showingBadgesHasCustomColor,
          'bg-grey': isDisabled
        }"
      >
        <showing-badge
          v-for="showingBadge in showingBadgesNoneTitleDisplay"
          :key="showingBadge.id"
          :size="isShowtimeGrid ? 'sm' : 'md'"
          :showing-badge="showingBadge"
          :force-icon="showingBadgesNoneTitleDisplay.length > 1 || (isShowtimeGrid && !isMoviePage)"
          :color="getIconColor"
          :badge-name-max-width="isShowingButton ? '130px' : undefined"
          dense
          class="q-mx-none q-pr-sm no-border bg-transparent q-pl-xs"
        />
        <q-chip
          v-if="showing.isNearCapacity && !showing.isSoldOut"
          square
          align="center"
          color="warning"
          text-color="negative"
          :size="isShowtimeGrid ? 'xs' : 'sm'"
          style="z-index: 1"
          class="rotate-90 absolute background-grey full-width"
          :dense="isShowtimeGrid"
          :style="{
            right: (isShowtimeGrid && ($q.screen.lt.md || compact ? '-48%' : '-45%')) ||
              (isMoviePage && ($q.screen.lt.md ? '-72px' : '-76px')) ||
              ($q.screen.lt.md ? '-46%' : '-44.5%') ,
            top: isShowtimeGrid ? '20px' : '35px'
          }"
        >
          <div
            class="text-center full-width "
          >
            {{ $tc('ticket.ticketsLeftCount', showing.seatsRemaining) }}
          </div>
        </q-chip>
        <q-chip
          v-if="showing.isSoldOut"
          square
          align="center"
          color="grey-5"
          :size="isShowtimeGrid ? 'xs' : 'sm'"
          text-color="negative"
          class="rotate-90 absolute background-grey full-width"
          style="z-index: 1"
          :style="{
            right: (isShowtimeGrid && ($q.screen.lt.md ? '-46%' : '-43%')) ||
              (isMoviePage && ($q.screen.lt.md ? '-72px' : '-76px')) ||
              ($q.screen.lt.md ? '-46%' : '-44.5%'),
            top: isShowtimeGrid ? '28px' : '35px',
          }"
        >
          <div class="text-center full-width">
            Sold out
          </div>
        </q-chip>
        <q-chip
          v-else-if="currentSite.showConsumerAttendanceBadge && showAttendanceLevels && (showing.predictedAttendance < 7 || showing.predictedAttendance > 20)"
          square
          color="transparent"
          :size="isShowtimeGrid? 'sm' : 'md'"
          dense
          :text-color="getIconColor"
          class="q-mx-none q-pa-none"
          icon="people"
        >
          <q-tooltip
            class="text-white"
            style="background-color: rgba(0, 0, 0, 0.5)"
          >
            {{ showing.predictedAttendance > 20 ?
              ('We are projecting a high turn out for this showing! Suggest arriving ' + Math.round(Math.max(showing.predictedAttendance / 3, 10)) + ' minutes before the start time.') :
              'Low projected attendance level, this is a great show to attend, beat the crowds!'
            }}
          </q-tooltip>
        </q-chip>
      </div>
    </q-btn>

    <q-tooltip
      v-if="salesEnabled && isDisabled"
    >
      {{ buttonDisabledMessage }}
    </q-tooltip>
  </div>
</template>
<script>

import { BUTTON_TYPES } from 'src/models/page/Section'
import Showing from 'src/models/showing/Showing'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'

export default {
  name: 'ShowtimesButtonDescriptive',
  components: {
    ShowingBadge
  },
  props: {
    showing: {
      type: Showing,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
    showAttendanceLevels: {
      type: Boolean,
      required: true
    },
    solidShowingBadges: {
      type: Boolean,
      required: true
    },
    isShowtimeGrid: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 3
    },
    isMoviePage: {
      type: Boolean,
      required: false,
      default: false
    },
    isShowtimesDarkMode: {
      type: Boolean,
      required: false,
      default: false
    },
    showButtonProgressBar: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    buttonColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    isShowingButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  configuration: ['currentSite'],
  emits: ['select-showing', 'show-held-seat-dialog'],
  computed: {
    salesEnabled () {
      return this.currentSite.hasOnlineTicketing
    },
    textColor () {
      if (!!this.buttonColor && this.buttonColor === 'custom') return this.$isColorDark(this.buttonColorHex) ? this.buttonColorHex : 'var(--q-dark)'
      return 'var(--q-primary)'
    },
    showingBadgesNoneTitleDisplay () {
      return _.filter(this.showing.showingBadges.data, showingBadge => !showingBadge.displayTitleOnButton)
    },
    showingBadgesTitleDisplay () {
      return _.filter(this.showing.showingBadges.data, showingBadge => !!showingBadge.displayTitleOnButton)
    },
    getIconColor () {
      let colorHex
      if (this.showingBadgesHasCustomColor) {
        colorHex = this.getShowingBadgeColor
      } else if (this.buttonColor === 'custom') {
        colorHex = this.buttonColorHex
      } else {
        colorHex = this.$getSiteColorHex(this.currentSite, this.buttonColor)
      }
      if (!colorHex) return false
      return this.$isColorDark(colorHex) ? 'white' : 'black'
    },
    buttonDisabledMessage () {
      return this.showing.hasPurchaseEmbargo ? this.$t('showing.ticketsGoOnSale', { time: this.$d(this.showing.embargoPurchaseLiftedAt, 'medium') }) : this.$t('showing.noLongerAvailableForPurchaseOnline')
    },
    showingBadgesHasCustomColor () {
      return _.some(this.showing.showingBadges.data.map(showingBadge => !_.isNil(showingBadge.color)))
    },
    getShowingBadgeColor () {
      if (!this.showingBadgesHasCustomColor) return null

      const conferPriorityColors = _(this.showing.showingBadges.data)
        .filter(showingBadge => showingBadge.conferPriority && !_.isNil(showingBadge.color))
        .map(showingBadge => showingBadge.color)
        .value()

      const colors = _(this.showing.showingBadges.data)
        .filter(showingBadge => !_.isNil(showingBadge.color))
        .map(showingBadge => showingBadge.color)
        .value()

      return conferPriorityColors.length > 0 ? conferPriorityColors[0] : colors[0]
    },
    getBackgroundColorHex () {
      if (this.showingBadgesHasCustomColor) {
        return this.getShowingBadgeColor
      } else {
        return !!this.buttonColor && this.buttonColor === 'custom' ? this.buttonColorHex : undefined
      }
    },
    getWidth () {
      if (this.isMoviePage) {
        return this.$q.screen.lt.md ? '155px' : '180px'
      } else {
        return this.$q.platform.is.firefox
          ? '-moz-available'
          : this.$q.platform.is.chrome || this.$q.platform.is.safari
            ? '-webkit-fill-available'
            : 'fill-available'
      }
    }
  },
  created () {
    _.extend(this, { BUTTON_TYPES })
  },
  methods: {
    getTextColor (color) {
      let colorHex
      if (color !== null) {
        colorHex = color
      } else {
        colorHex = this.$getSiteColorHex(this.currentSite, 'warning')
      }
      return this.$isColorDark(colorHex) ? 'white' : 'black'
    },
    dragScrollMove (ev) {
      const area = this.$refs.scrollHorizontal

      if (ev.isFirst === true) {
        this.initialScrollX = area.getScrollPosition().left
      }

      area.setScrollPosition('horizontal', (this.initialScrollX || 0) - ev.offset.x)
    }
  }
}
</script>
<style lang="scss">
  .q-btn__content_full_width .q-btn__content{
    width: 100%;
  }
</style>
